module.exports = __webpack_public_path__ + "img/aside-tit2.d8b8e164.png";